<xi-drawer
  #drawer
  [open]="open"
  [interceptClose]="true"
  (onClose)="cancel()"
  color="CX"
  [silverBg]="false"
  *transloco="let t; read: 'create-comparison-drawer-component'"
>
  <div slot="title">{{ t('x-comparison', { action: comparison ? t('edit') : t('create') }) }}</div>
  <div slot="body">
    <section>
      <div class="section-title">
        <h3>{{ t('general-details') }}</h3>

        <p>
          {{ t('general-body') }}
        </p>
      </div>

      <div class="section-field create-comparison__general-details">
        <xi-input-field
          label="{{ t('comparison-label') }}"
          name="comparisonName"
          placeholder="{{ t('placeholder') }}"
          type="text"
          [(ngModel)]="name"
          [status]="nameStatus"
          (onChange)="onValidateName()"
        ></xi-input-field>

        <div class="create-comparison__color-picker">
          <label class="kxi-input-label kxi-normal-contrast">{{ t('swatch') }}</label>

          <xi-color-picker
            [direction]="6"
            label="{{ t('swatch') }}"
            [preselectedColors]="projectColorPalette"
            [selectedColor]="color"
            (onColorChange)="colorChange$.next($event.detail.color)"
          ></xi-color-picker>
        </div>
      </div>
    </section>

    <section>
      <div class="section-title">
        <h3>{{ t('comparison-filters') }}</h3>

        <p class="text-pre-line">
          {{ t('filter-definition') }}
        </p>
      </div>

      <div class="section-field create-comparison__filter-section">
        <xi-dropdown
          placeholder="{{ t('type-placeholder') }}"
          label="{{ t('type-label') }}"
          [stretch]="true"
          [value]="type"
          [data]="comparisonTypes"
          [disabled]="!!filters.length"
          (onValueChange)="onTypeChange($event.detail.selected.id)"
        ></xi-dropdown>

        <div class="create-comparison__filter-section-header">
          <span> {{ t('comparison-filter') }} </span>

          <xi-default-button
            #addFilterButton
            text="{{ t('add-filter') }}"
            fill="no-fill"
            buttonSize="small"
            iconLeft="add_circle"
            [disabled]="!type || !dataSources || !defaultColorPalette"
            (onClick)="onAddFilter()"
          ></xi-default-button>

          <xi-popout
            [isVisible]="isAddFilterPopoutVisible"
            [anchorElement]="addFilterButton"
            [internalPadding]="0"
            (onExternalPress)="isAddFilterPopoutVisible = false"
            ><div slot="children">
              <xi-list>
                <div slot="children">
                  <xi-list-item
                    [value]="0"
                    [disabled]="!regularDateRangeEnabled"
                    [tooltip]="
                      !regularDateRangeEnabled
                        ? {
                            text: t('date-range-disabled-tooltip'),
                          }
                        : null
                    "
                    (onItemClick)="onAddDateFilter('regularDate')"
                  >
                    <div slot="children">{{ t('date-range') }}</div>
                  </xi-list-item>
                  <xi-list-item
                    [value]="1"
                    [disabled]="!dynamicDateRangeEnabled"
                    [tooltip]="
                      !dynamicDateRangeEnabled
                        ? {
                            text: t('dynamic-date-range-disabled-tooltip'),
                          }
                        : null
                    "
                    (onItemClick)="onAddDateFilter('dynamicDate')"
                  >
                    <div slot="children">{{ t('dynamic-date-range') }}</div>
                  </xi-list-item>
                </div>
              </xi-list>
            </div></xi-popout
          >
        </div>

        @if (filters.length) {
          <div class="create-comparison__filter-section-body">
            @for (filter of filters; track filter; let i = $index) {
              <app-comparison-filter-item
                [allFilters]="filters"
                [field]="selectedDataField"
                [fieldExtra]="selectedFieldExtra"
                [type]="type"
                [subType]="filter.subType"
                [filters]="filter"
                [projectId]="projectId"
                [projectColors]="projectColorPalette"
                [(filtersLabel)]="filter.label"
                [filterLabelStatus]="filterLabelStatuses[i]"
                [filtersColor]="filtersColors[i]"
                (filtersColorChange)="onFilterColorChange($event, i)"
                [isReadOnly]="true"
                (filtersRemove)="onFiltersRemoved(i)"
                (filtersLabelChange)="onValidateFilterLabel(filter, i)"
                (filtersChange)="onFiltersChange($event, i)"
              ></app-comparison-filter-item>
            }
          </div>
        } @else {
          <div
            class="create-comparison__filter-section-body create-comparison__filter-section-body--empty"
          >
            {{ t('create-filter') }}
          </div>
        }
      </div>
    </section>
  </div>

  <div slot="footer" class="create-configuration__actions">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="comparison ? t('update') : t('create')"
        [disabled]="!isNameValid || !areLabelsValid || !isDynamicDateValid || filters.length === 0"
        (onClick)="save()"
      ></xi-default-button>
    </div>
  </div>
</xi-drawer>

@if (showCreateComparisonModal) {
  <app-lex-xi-modal [isVisible]="showCreateComparisonModal" (close)="onCreateFilterModalClosed()">
    <ng-template appXIModalContent>
      @if (showCreateComparisonModal) {
        <app-create-comparison-filter-dialog
          [options]="{
            allFilters: filters,
            dataSources: selectableDataSources,
            type: type,
            dateType: dateType,
            projectId: projectId,
            selectedDataSourceId: selectedDataSourceId,
            selectedDataField: selectedDataField,
            existingFilterLabels: existingFilterLabels,
            filters: filters[0],
            activeFilterColor: activeFilterColor,
          }"
          (modalClosed)="onCreateFilterModalClosed($event)"
        ></app-create-comparison-filter-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
